"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPcmEstimatedDeliveryDates = exports.addBusinessDays = exports.POST_MAIL_PCM_FIRST_CLASS_LATEST_BUSINESS_DAYS = exports.POST_MAIL_PCM_FIRST_CLASS_EARLIEST_BUSINESS_DAYS = exports.POST_MAIL_PCM_STANDARD_LATEST_BUSINESS_DAYS = exports.POST_MAIL_PCM_STANDARD_EARLIEST_BUSINESS_DAYS = void 0;
const post_mail_1 = require("../enums/post-mail");
exports.POST_MAIL_PCM_STANDARD_EARLIEST_BUSINESS_DAYS = 12;
exports.POST_MAIL_PCM_STANDARD_LATEST_BUSINESS_DAYS = 15;
exports.POST_MAIL_PCM_FIRST_CLASS_EARLIEST_BUSINESS_DAYS = 5;
exports.POST_MAIL_PCM_FIRST_CLASS_LATEST_BUSINESS_DAYS = 7;
const addBusinessDays = (startDate, businessDays) => {
    const result = new Date(startDate);
    let added = 0;
    while (added < businessDays) {
        result.setUTCDate(result.getUTCDate() + 1);
        const dayOfWeek = result.getUTCDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            added += 1;
        }
    }
    return result;
};
exports.addBusinessDays = addBusinessDays;
const getPcmBusinessDayWindow = (mailingClass) => {
    if (mailingClass === post_mail_1.PostMailMailingClass.FirstClass) {
        return {
            earliestBusinessDays: exports.POST_MAIL_PCM_FIRST_CLASS_EARLIEST_BUSINESS_DAYS,
            latestBusinessDays: exports.POST_MAIL_PCM_FIRST_CLASS_LATEST_BUSINESS_DAYS,
        };
    }
    return {
        earliestBusinessDays: exports.POST_MAIL_PCM_STANDARD_EARLIEST_BUSINESS_DAYS,
        latestBusinessDays: exports.POST_MAIL_PCM_STANDARD_LATEST_BUSINESS_DAYS,
    };
};
const getPcmEstimatedDeliveryDates = ({ anchorDate, mailingClass, }) => {
    const { earliestBusinessDays, latestBusinessDays } = getPcmBusinessDayWindow(mailingClass);
    return {
        estimatedDeliveryEarliest: (0, exports.addBusinessDays)(anchorDate, earliestBusinessDays).toISOString(),
        estimatedDeliveryLatest: (0, exports.addBusinessDays)(anchorDate, latestBusinessDays).toISOString(),
    };
};
exports.getPcmEstimatedDeliveryDates = getPcmEstimatedDeliveryDates;
